<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-12 col-md-12">
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="complaint-dashboard">
  <!-- Complaint Type Cards -->
  <div class="row mb-4">
    @for (card of complaintCards; track card) {
    <div class="col-md-3">
      <div
        class="card complaint-card"
        [ngClass]="{ active: selectedComplaintType === card.wrk_grp_id }"
        (click)="onCardSelect(card)"
        [ngStyle]="{ 'border-color': card.color }"
      >
        <div class="card-body">
          <div class="card-title" [ngStyle]="{ color: card.color }">
            {{ card.wrk_grp_nm }}
            <span class="total-count">({{ card.total }})</span>
          </div>
          <div class="row stats">
            <div class="col-6">
              <div class="stat-value pending">{{ card.pending }}</div>
              <div class="stat-label">Pending</div>
            </div>
            <div class="col-6">
              <div class="stat-value completed">{{ card.completed }}</div>
              <div class="stat-label">Completed</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Tickets Grid -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          @if (selectedCard) {
          <h5 class="card-title">{{ selectedCard.wrk_grp_nm }} Tickets</h5>
          }
          <app-data-grid
            [headerFilter]="true"
            [dataSource]="ticketsData"
            [legacyColumns]="columnDefs"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="export"
            [pageSize]="10"
            [allowedPageSizes]="[10, 25, 50]"
            [showPageSizeSelector]="true"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            (rowClick)="onRowClick($event)"
          >
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>
